module.exports = __webpack_public_path__ + "img/logo2.ba00d5fa.svg";